import FileSaver from 'file-saver'
import JSZip from 'jszip'

async function exportFiles(files, zipName) {
  const downloadedFiles = await Promise.all(
    files.map(async file => {
      const blob = await download(file.url)
      const fileExtension = file.url.replace(/.+\/.+(\..+)/, '$1')
      return {
        name: `${file.name || file.url}${fileExtension}`,
        blob,
      }
    }),
  )
  await exportZip(downloadedFiles, zipName)
  return { statusCode: 200, message: 'exported', data: null }
}

async function download(url) {
  return fetch(url).then(resp => resp.blob())
}

async function exportZip(files, zipName) {
  const zip = JSZip()
  files.forEach(file => {
    zip.file(file.name, file.blob)
  })
  const zipFile = await zip.generateAsync({ type: 'blob' })
  const currentDate = new Date().getTime()
  const fileName = (zipName || `files-${currentDate}`) + '.zip'
  return FileSaver.saveAs(zipFile, fileName)
}

export { exportFiles }
